/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientCarePeriod
 */
export interface PccPatientCarePeriod {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    start_date?: string | null;
    /**
     * 
     */
    end_date?: string | null;
    /**
     * 
     */
    period_type?: PccPatientCarePeriodPeriodTypeEnum;
    /**
     * 
     */
    pcc_care_period_id?: string;
}


/**
 * @export
 */
export const PccPatientCarePeriodPeriodTypeEnum = {
    Encounter: 'ENCOUNTER',
    PatientHistory: 'PATIENT_HISTORY',
} as const;
export type PccPatientCarePeriodPeriodTypeEnum = typeof PccPatientCarePeriodPeriodTypeEnum[keyof typeof PccPatientCarePeriodPeriodTypeEnum];


/**
 * Check if a given object implements the PccPatientCarePeriod interface.
 */
export function instanceOfPccPatientCarePeriod(value: object): value is PccPatientCarePeriod {
    return true;
}

export function PccPatientCarePeriodFromJSON(json: any): PccPatientCarePeriod {
    return PccPatientCarePeriodFromJSONTyped(json, false);
}

export function PccPatientCarePeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientCarePeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'start_date': json['start_date'] === undefined ? undefined : json['start_date'] === null ? null : json['start_date'],
        'end_date': json['end_date'] === undefined ? undefined : json['end_date'] === null ? null : json['end_date'],
        'period_type': json['period_type'] == null ? undefined : json['period_type'],
        'pcc_care_period_id': json['pcc_care_period_id'] == null ? undefined : json['pcc_care_period_id'],
    };
}

export function PccPatientCarePeriodToJSON(json: any): PccPatientCarePeriod {
    return PccPatientCarePeriodToJSONTyped(json, false);
}

export function PccPatientCarePeriodToJSONTyped(value?: PccPatientCarePeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'start_date': value['start_date'],
        'end_date': value['end_date'],
        'period_type': value['period_type'],
        'pcc_care_period_id': value['pcc_care_period_id'],
    };
}

